module.exports = __webpack_public_path__ + "img/36_62.db06588b.png";